var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 145.34C63.375 145.34 44.7005 134.524 33.8 118.3C34.0535 101.4 67.6 92.105 84.5 92.105C101.4 92.105 134.946 101.4 135.2 118.3C124.299 134.524 105.625 145.34 84.5 145.34ZM84.5 25.35C91.2232 25.35 97.6711 28.0208 102.425 32.7748C107.179 37.5289 109.85 43.9768 109.85 50.7C109.85 57.4232 107.179 63.8711 102.425 68.6252C97.6711 73.3792 91.2232 76.05 84.5 76.05C77.7768 76.05 71.3289 73.3792 66.5748 68.6252C61.8208 63.8711 59.15 57.4232 59.15 50.7C59.15 43.9768 61.8208 37.5289 66.5748 32.7748C71.3289 28.0208 77.7768 25.35 84.5 25.35V25.35ZM84.5 0C73.4033 0 62.4153 2.18566 52.1632 6.43218C41.9112 10.6787 32.596 16.9029 24.7495 24.7495C8.90265 40.5963 0 62.0892 0 84.5C0 106.911 8.90265 128.404 24.7495 144.251C32.596 152.097 41.9112 158.321 52.1632 162.568C62.4153 166.814 73.4033 169 84.5 169C106.911 169 128.404 160.097 144.251 144.251C160.097 128.404 169 106.911 169 84.5C169 37.7715 130.975 0 84.5 0Z",
    fill: "#6FCF97",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.aa486d5d.svg";
export { ForwardRef as ReactComponent };